import React from 'react'
import Box from 'components/Box'
import SignedInHeaderPortal from 'components/Layout/components/Sidebar/components/SignedInHeader/components/SignedInHeaderPortal'
import { makeStyles } from 'tss-react/mui'
import { useMediaQuery } from 'hooks/useMediaQuery'
import { useTheme } from '@mui/material/styles'

interface IPageTopHeaderProps {
  children: React.ReactNode
}

const useStyles = makeStyles()(theme => ({
  container: {
    background: 'white',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(1),
    },
  },
  wrapper: {
    marginBottom: theme.spacing(-1),
  },
}))

const PageTopHeader: React.FunctionComponent<IPageTopHeaderProps> = (props: IPageTopHeaderProps) => {
  const { classes } = useStyles()
  const { children } = props

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(t => t.breakpoints.down('sm'))

  return (
    <SignedInHeaderPortal>
      <div className={classes.container}>
        <Box style={{ paddingBottom: isSmallScreen ? theme.spacing(1) : theme.spacing(3) }}>
          <div className={classes.wrapper}>
            {children}
          </div>
        </Box>
      </div>
    </SignedInHeaderPortal>
  )
}

export default PageTopHeader
